import ApiService from './api.service';
import config from '../config.js';

export default {
  async getFile(params) {
    return await ApiService.get('/configurations', {
      params
    });
  },
  async getConfigurationProfile() {
    return await ApiService.get(`/configurations/profile?sid=${config.serviceId}`);
  }
};
